import { defineComponent as _defineComponent } from 'vue'
import { useBreakpoint, useMediaAsset, useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryRecommended',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
  },
};

const swiperEl = useSwiperElement(swiperOptions);

return { __sfc: true,getAssetUrl, isDesktop, swiperOptions, swiperEl }
}

})